import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type PaymentWayRequestBody = components['schemas']['PaymentWayRequestBody'];

type CreatePaymentWayOperation = paths['/executor_web/payment_ways']['post'];

export type CreatePaymentWayRequest = NonNullable<
	NonNullable<CreatePaymentWayOperation['requestBody']>['content']['application/json']
>;
export type CreatePaymentWayResponse =
	CreatePaymentWayOperation['responses'][200]['content']['application/json'];
export type CreatePaymentWayErrorResponse =
	CreatePaymentWayOperation['responses'][400]['content']['application/json'];

/** POST `/executor_web/payment_ways` — см. `paths['/executor_web/payment_ways']` в auth swagger */
export function createPaymentWay(request: CreatePaymentWayRequest, signal?: AbortSignal) {
	return axiosInstance.post<CreatePaymentWayResponse>('payment_ways', request, {signal});
}
